module.exports = __webpack_public_path__ + "img/jcb.e8a9f1bc.svg";